<i18n>
{
  "en": {
    "free": {
      "title": "Free",
      "price": "{0}0.00",
      "texts": [
        "{0} Only 10 contacts converted to VCard"
      ],
      "cta": "Download VCard"
    },
    "month": {
      "title": "Personal",
      "price": "{0}1.99",
      "texts": [
        "{0} 30 days licence",
        "{0} Unlimited contacts conversion",
        "{0} Unlimited files conversion"
      ],
      "cta": "Download VCard"
    },
    "lifetime": {
      "title": "Enterprise",
      "price": "{0}11.99",
      "texts": [
        "{0} Lifetime licence",
        "{0} Unlimited contacts conversion",
        "{0} Unlimited files conversion"
      ],
      "cta": "Download VCard"
    },
    "modal": {
      "title": "Signup to download"
    }
  }
}
</i18n>

<script>
import { getters, downloadContacts } from '@/config/store';
import SignupForm from '@/components/SignupForm.vue';
import DownloadPlan from '@/components/DownloadPlan.vue';

export default {
  components: {
    SignupForm,
    DownloadPlan,
  },

  props: {
    type: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      chosenPlan: 'free',
      signupModalOpened: false,
    };
  },

  methods: {
    onComplete() {
      switch (this.chosenPlan) {
        case 'month':
          this.processMonth();
          break;
        case 'lifetime':
          this.processLifetime();
          break;
        case 'free':
        default:
          this.processFree();
      }

      this.signupModalOpened = false;
    },
    processFree() {
      if (getters.isLoggedin) {
        downloadContacts(this.type, true);
        this.$trackCategory('CONVERT', `download - ${this.chosenPlan}`, this.type);
      } else {
        this.chosenPlan = 'free';
        this.signupModalOpened = true;
        this.$trackCategory('CONVERT', `click plan - ${this.chosenPlan}`, this.type);
      }
    },
    processMonth() {
      if (getters.isLoggedin && (!getters.hasPaidMonth || getters.monthPLanDaysLeft < 0)) {
        this.$pay('month');
        this.$trackCategory('PAYMENT', `stripe - ${this.chosenPlan}`, this.type);
      } else if (getters.isLoggedin && getters.canDownloadFull) {
        downloadContacts(this.type, false);
        this.$trackCategory('CONVERT', `download - ${this.chosenPlan}`, this.type);
      } else {
        this.chosenPlan = 'month';
        this.signupModalOpened = true;
        this.$trackCategory('CONVERT', `click plan - ${this.chosenPlan}`, this.type);
      }
    },
    processLifetime() {
      if (getters.isLoggedin && !getters.hasPaidLifetime) {
        this.$pay('lifetime');
        this.$trackCategory('PAYMENT', `stripe - ${this.chosenPlan}`, this.type);
      } else if (getters.isLoggedin && getters.canDownloadFull) {
        downloadContacts(this.type, false);
        this.$trackCategory('CONVERT', `download - ${this.chosenPlan}`, this.type);
      } else {
        this.chosenPlan = 'lifetime';
        this.signupModalOpened = true;
        this.$trackCategory('CONVERT', `click plan - ${this.chosenPlan}`, this.type);
      }
    },
  },
};
</script>

<template>
  <section class="py-10 bgc-light text-center">
    <div class="plans container flex jcontent-center">
      <download-plan class="w-1-3">
        <template #title>
          <p v-t="'free.title'" />
        </template>
        <template #price>
          <i18n tag="p" path="free.price">
            <sup>&dollar;</sup>
          </i18n>
        </template>
        <template #default>
          <i18n tag="p" path="free.texts[0]">
            <span class="color-main">✓</span>
          </i18n>
        </template>
        <template #cta>
          <button type="button" class="btn fw-700 w-full" v-t="'free.cta'" @click="processFree" />
        </template>
      </download-plan>

      <download-plan class="w-1-3">
        <template #title>
          <p v-t="'month.title'" />
        </template>
        <template #price>
          <i18n tag="p" path="month.price">
            <sup>&dollar;</sup>
          </i18n>
        </template>
        <template #default>
          <i18n v-for="n in 3" :key="n" tag="p" :path="`month.texts[${n - 1}]`">
            <span class="color-main">✓</span>
          </i18n>
        </template>
        <template #cta>
          <button type="button" class="btn fw-700 w-full" v-t="'month.cta'" @click="processMonth" />
        </template>
      </download-plan>

      <download-plan class="w-1-3">
        <template #title>
          <p v-t="'lifetime.title'" />
        </template>
        <template #price>
          <i18n tag="p" path="lifetime.price">
            <sup>&dollar;</sup>
          </i18n>
        </template>
        <template #default>
          <i18n v-for="n in 3" :key="n" tag="p" :path="`lifetime.texts[${n - 1}]`">
            <span class="color-main">✓</span>
          </i18n>
        </template>
        <template #cta>
          <button type="button" class="btn fw-700 w-full" v-t="'lifetime.cta'" @click="processLifetime" />
        </template>
      </download-plan>
    </div>

    <teleport to="modals">
      <base-modal
        v-if="signupModalOpened"
        :active.sync="signupModalOpened"
        :title="$t('modal.title')">
        <signup-form :plan="chosenPlan" @complete="onComplete" />
      </base-modal>
    </teleport>
  </section>
</template>

<style lang="scss" scoped>
@include touch {
  .plans {
    display: block;
  }

  .w-1-3 {
    width: 100%;
    margin-left: 0;
    margin-bottom: 10px;
  }

  .py-10 {
    padding: 0;
  }
}
</style>
